import React from 'react'
import { Form, Row, Col, DropdownButton, Dropdown } from 'react-bootstrap'

// components
import { ArrowRight } from 'react-feather'
import XeroLogo from '../../../../images/xero-logo.svg'
import StripeLogo from '../../../../images/stripe-logo.svg'

// definitions
import { AccountStripeOrgWithData, AccountXeroOrgWithData } from '../../../../screens/subsync/subsync'
import { DetailedStripeOrgAccountXeroOrg } from '../settings'
import { StripeOrgAccountXeroOrgBankFeed } from '../../../../../../back-end/common/stripeOrgAccountXeroOrgBankFeed'

interface OrgMappingHeaderProps {
	stripeOrg: AccountStripeOrgWithData
	orgMappings: DetailedStripeOrgAccountXeroOrg[]
	orgMapping: DetailedStripeOrgAccountXeroOrg | undefined
	mappedXeroOrg: AccountXeroOrgWithData | undefined
	xeroOrgs: AccountXeroOrgWithData[]
	bankFeed: StripeOrgAccountXeroOrgBankFeed | undefined
	handleOrgUpdate: (stripeOrgID: string, name: string, value: string) => void
	handleOrgAdd: (stripeOrgID: string, value: string) => void
}

const OrgMappingHeader = (props: OrgMappingHeaderProps) => {
	const stripeID = props.stripeOrg.stripeOrg?.stripeID?.replace('acct_', '')
	// Detects Xero's own native Stripe bank feed, which names the account after the Stripe account id
	const mappedXeroOrgHasStripeBankAccount = stripeID && props.mappedXeroOrg?.accounts.find((acc) => acc.number?.includes(stripeID))
	// Our own Stripe Bank Feed does the same job, and its account carries no such number. Only an ACTIVE feed
	// counts - in every other state the backend falls back to the account number match, so the warning still holds.
	const hasSubSyncBankFeed = props.bankFeed?.status === 'ACTIVE'

	return (
		<>
			<Form.Group as={Row} style={{ marginBottom: '0px', marginLeft: '0px', display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>
				<Col sm="1" />
				<input type="image" alt="xero-logo" style={{ width: '40px', borderRadius: '25px' }} src={StripeLogo} />
				<Col sm="2" style={{ display: 'flex', alignItems: 'center' }}>
					<div className="subsync-settings-label">{props.stripeOrg.stripeOrg!.name}</div>
				</Col>
				<Col
					sm="2"
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-evenly',
					}}
				>
					<ArrowRight></ArrowRight>
				</Col>
				<input type="image" alt="xero-logo" style={{ width: '40px' }} src={XeroLogo} />
				<Col sm="3">
					<DropdownButton
						id={`${props.stripeOrg.stripeOrg!.stripeOrgID}-mapping-org-select`}
						title={props.mappedXeroOrg?.xeroOrg?.name || 'Select Xero Org'}
						onSelect={(eventKey) =>
							props.orgMapping
								? props.handleOrgUpdate(props.stripeOrg.stripeOrg!.stripeOrgID!, 'accountXeroOrgID', eventKey!)
								: props.handleOrgAdd(props.stripeOrg.stripeOrg!.stripeOrgID!, eventKey!)
						}
					>
						{props.mappedXeroOrg && <Dropdown.Item eventKey={''}>Remove mapping</Dropdown.Item>}
						{props.xeroOrgs.map((xo) => (
							<Dropdown.Item key={xo.accountXeroOrgID} eventKey={xo.accountXeroOrgID}>
								{xo.xeroOrg!.name}
							</Dropdown.Item>
						))}
					</DropdownButton>
				</Col>
			</Form.Group>
			<Row>
				<Col>
					{!hasSubSyncBankFeed && !mappedXeroOrgHasStripeBankAccount && (
						<div className="mb-3 subsync-no-feed-message">
							We couldn&apos;t detect a Stripe Bank Feed in this Xero connection. This means payments from Stripe won&apos;t be automatically
							reflected in Xero.
						</div>
					)}
				</Col>
			</Row>
		</>
	)
}

export { OrgMappingHeader }
